import { Component, inject, Input, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Roles, ROLES_MESSAGE_MAP } from '../../../../core/constants/roles.enum';
import { KYC_STATUS_MAP, KYC_STATUS_NUMBER_MAP, KycStatus } from '../../../../core/constants/kyc-status.enum';
import { Attachment, DocumentType } from '../../../models/attachment.model';
import { AttachmentPreviewManager } from '../../../managers/attachment-preview.manager';
import { StateIndividual } from '../../../models/individual.model';
import { SharedService } from '../../../services/shared.service';
import { AttachmentService } from '../../../services/attachment.service';

@Component({
    selector: 'app-payment-individual-modal',
    templateUrl: './payment-individual-modal.component.html',
    styleUrls: ['./payment-individual-modal.component.scss'],
    standalone: false
})
export class PaymentIndividualModalComponent implements OnInit {

  //@ts-ignore
  @Input() individual: StateIndividual;
  @Input() isPayer: boolean = false;
  @Input() isRecipient: boolean = false;

  isVisible: boolean = true;
  excludedRoles: Roles[] = [Roles.PAYR, Roles.PCNT, Roles.RCPT];
  KycStatus = KycStatus;

  kycReport: Attachment | null = null;
  kycIdentityDocs: Attachment[] | null = null;

  public readonly nzModalData: any = inject(NZ_MODAL_DATA);

  constructor(public modal: NzModalRef<PaymentIndividualModalComponent>,
    private attachmentService: AttachmentService,
    private shared: SharedService,
    private attachmentPreviewManager: AttachmentPreviewManager
  ) {

  }

  ngOnInit(): void {
    this.individual = this.nzModalData.individual;
    this.isPayer = this.nzModalData.isPayer;
    this.isRecipient = this.nzModalData.isRecipient;

    this.kycReport = this.attachmentService.attachments.find(i => i.documentType == DocumentType.KYC_REPORT && i.documentId == this.individual.kycData?.reportDocumentId) || null;
    this.kycIdentityDocs = this.attachmentService.attachments.filter(i => i.documentType == DocumentType.KYC_IDENTITY_DOC && this.individual.kycData?.identityDocumentIds?.includes(i.documentId)) || null;
  }


  isResident(): boolean {
    return this.individual.address?.country?.id == 115;
  }

  mapRoleToText(role: string): string {
    return ROLES_MESSAGE_MAP.get(role) || role;
  }

  getFilteredJobTitlesIndividual(individual: StateIndividual): Roles[] {
    return individual.jobTitles.map(role => role.titleCode as Roles).filter(role => !this.excludedRoles.includes(role));
  }

  getKycStatus(status: string): string {
      return KYC_STATUS_MAP.get(status as KycStatus) || KYC_STATUS_NUMBER_MAP.get(status) || status.toString();
  }

  previewFile(att: Attachment) {
    this.attachmentPreviewManager.openPreview({ fileId: att.documentId, fileName: att.fileName, applicationId: att.backOfficeApplicationId});
  }
}
